export default "__VITE_ASSET__a07357ea__"